<script>
/**
 * @overview 全局创建样式组件
 *
 * @author huojinzhao
 */

export default {
  name: "AppLabel",

  props: {
    width: {
      type: String,
      default: "200px",
    },

    height: {
      type: String,
      default: "200px",
    },
    offsetTop: [Number, String],
  },
  data() {
    return {
      newOffsetTop: this.offsetTop,
    };
  },

  computed: {
    style() {
      return { width: this.width, height: this.height };
    },
  },
  watch: {
    offsetTop(vl) { this.newOffsetTop = vl; },
    newOffsetTop(vl) { this.$emit('update:offsetTop', vl); },
  },
  mounted() {
    this.$nextTick(() => {
      this.newOffsetTop = this.$refs.label.offsetTop;
    });
  },
};
</script>

<template>
  <label
    ref="label"
    :style="style"
    class="app-create-label"
    @click="$emit('create')"
  >
    <slot name="file" />

    <slot name="placeholder">
      <i
        class="
          el-icon-plus
          layout-placeholder
          app-create-label__placeholeder
        "
      />
    </slot>
  </label>
</template>

<style lang="postcss">
.app-create-label {
  display: inline-block;
  cursor: pointer;
}

.app-create-label__placeholeder {
  font-size: 80px;
}
</style>
